import React from 'react'
import MaterialSymbol from '../material-symbol'

const People = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="people" {...props} />
))

People.displayName = 'People'

export default People
